import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiGetAllClients } from 'services/AdminService';

export const getClientData = createAsyncThunk('client/GetallClient', async (user) => {
    const response = await apiGetAllClients(user);
    return response.clients;
});

const initialState = {
    accessToken: '',
    refreshToken: '',
    sessionId: '',
    signedIn: false,
    permissions: [],
    navigation: [],
    selectedClientId: null,
    clients: [],
}

export const sessionSlice = createSlice({
    name: 'auth/session',
    initialState,
    reducers: {
        setAuthSession: (state, action) => {
            const { accessToken = '', refreshToken = '', sessionId = '' } = action.payload || {}
            state.accessToken = accessToken
            state.refreshToken = refreshToken
            state.sessionId = sessionId
            state.signedIn = Boolean(accessToken)
        },
        onSignInSuccess: (state, action) => {
            const { accessToken = '', refreshToken = '', sessionId = '' } = action.payload || {}
            state.signedIn = Boolean(accessToken)
            state.accessToken = accessToken
            state.refreshToken = refreshToken
            state.sessionId = sessionId
        },
        onSignOutSuccess: (state) => {
            state.signedIn = false
            state.accessToken = ''
            state.refreshToken = ''
            state.sessionId = ''
            state.permissions = []
            state.navigation = []
            state.selectedClientId = null
            state.clients = []
        },
        setClientId: (state, action) => {
            state.selectedClientId = action.payload;
        }
    },
    extraReducers: {
        [getClientData.fulfilled]: (state, action) => {
            state.clients = action.payload
            state.loading = false
        },
        [getClientData.pending]: (state) => {
            state.loading = true
        }
    }
});

export const { onSignInSuccess, onSignOutSuccess, setAuthSession, setClientId } = sessionSlice.actions;
export default sessionSlice.reducer;
